






    import 'reflect-metadata';
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component
    export default class DoroButton extends Vue {
        @Prop() public readonly src!: string;
    }
